<template lang="pug">
menu-item(:label=`$t('pretty_picture')`)
  menu-item(:label=`$t('m31')`, v-model="frameStore.paramsWindow.m31.isOpen")
  menu-item(:label=`$t('m42')`, v-model="frameStore.paramsWindow.m42.isOpen")
  menu-item(:label=`$t('m45')`, v-model="frameStore.paramsWindow.m45.isOpen")
  menu-item(:label=`$t('m101')`, v-model="frameStore.paramsWindow.m101.isOpen")
  menu-item(:label=`$t('perseus_cluster')`, v-model="frameStore.paramsWindow.perseus.isOpen")
</template>


<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  props: {
    frameStore: { required: true },
  },
})
</script>


<i18n>
en:
  pretty_picture: Pretty Picture
  m31: M31
  m42: M42
  m45: M45
  m101: M101
  perseus_cluster: Perseus Cluster
ja:
  pretty_picture: 星雲・近くの銀河など
  m31: M31
  m42: M42
  m45: M45
  m101: M101
  perseus_cluster: ペルセウス銀河団

</i18n>